var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "send-sms-posta-guvercini" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.sendSms"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("message.sendSmsYourCustomers"))),
        ]),
      ]),
      _vm._v(" "),
      _c("SendSmsInput", {
        attrs: { channel: _vm.channel, credit: _vm.credit },
        on: { sendSMS: _vm.sendSMS },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }